import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { User, LogOut, Shield } from 'lucide-react';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between py-3 md:py-0 md:h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/v2.png"
              alt="WECode"
              className="h-8 w-auto object-contain"
            />
            <span className="sr-only">WECode</span>
          </Link>

          <div className="flex flex-col md:flex-row md:items-center md:space-x-6 space-y-2 md:space-y-0">
            <Link to="/events" className="text-gray-600 hover:text-primary-600 transition-colors text-sm md:text-base">
              Events
            </Link>
            
            {user ? (
              <>
                <Link to="/schedule" className="text-gray-600 hover:text-primary-600 transition-colors text-sm md:text-base">
                  My Schedule
                </Link>
                <Link to="/attendees" className="text-gray-600 hover:text-primary-600 transition-colors text-sm md:text-base">
                  Attendees
                </Link>

                {isAdmin && (
                  <div className="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-2 md:space-y-0">
                    <Link to="/admin/dashboard" className="flex items-center space-x-1 text-red-600 hover:text-red-700 transition-colors font-medium text-sm md:text-base">
                      <Shield className="h-4 w-4" />
                      <span>Admin</span>
                    </Link>
                    <Link to="/admin/events" className="text-red-600 hover:text-red-700 transition-colors font-medium text-sm md:text-base">
                      Manage Events
                    </Link>
                  </div>
                )}

                <div className="flex items-center space-x-3 md:space-x-4">
                  <Link to="/dashboard" className="flex items-center space-x-2 text-gray-700 hover:text-primary-600 transition-colors">
                    <User className="h-4 w-4 text-gray-500" />
                    <span className="text-sm font-medium">{user.name}</span>
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="flex items-center space-x-1 text-gray-600 hover:text-red-600 transition-colors text-sm md:text-base"
                  >
                    <LogOut className="h-4 w-4" />
                    <span>Logout</span>
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-3">
                <Link to="/login" className="btn-secondary text-sm md:text-base">
                  Login
                </Link>
                <Link to="/register" className="btn-primary text-sm md:text-base">
                  Register
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 